// Widget Scripts
import cardWidget from './js/widgets/cardWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import * as socialNetworkWidget from './js/widgets/socialNetworkWidget';
import videoWidget from './js/widgets/videoWidget.js';
import sponsorwidgetcontainer from './js/widgets/cssSponsors.js';
import cardWidgetmap from './js/widgets/cardWidgetMap.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    cardWidget();
    swiperWidget();
    seoWidget();
    sponsorwidgetcontainer();
    videoWidget();
    cardWidgetmap();
    multiScheduleFeature();
    $(window).load(function () {
      socialNetworkWidget.facebookfeed(true);
    });
  });
}
